(function () {
  function moneyFromCents(cents) {
    var value = Number(cents) / 100;
    if (Number.isNaN(value)) return '';
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  function discountedUnitCents(unitCents, percent) {
    if (!percent) return unitCents;
    return Math.round((unitCents * (100 - percent)) / 100);
  }

  function setQuantity(form, qty) {
    var input = form.querySelector('input[name="quantity"]');
    if (!input) return;
    input.value = String(qty);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setSlot(root, slot, cents) {
    root.querySelectorAll('[data-price-slot="' + slot + '"]').forEach(function (el) {
      el.textContent = moneyFromCents(cents);
    });
  }

  function updateMainPrice(root, cents, compareCents) {
    var productPrice = root.querySelector('product-price');
    if (!productPrice) {
      var fallback = root.querySelector('.price__regular .price, .price');
      if (fallback && fallback.childElementCount === 0) {
        fallback.textContent = moneyFromCents(cents);
      }
      return;
    }

    var regularWrap = productPrice.querySelector('.price__regular');
    var saleWrap = productPrice.querySelector('.price__sale');
    var regularPrice = productPrice.querySelector('.price__regular .price');
    var salePrice = productPrice.querySelector('.price__sale .price');
    var comparePrice = productPrice.querySelector('.price__sale .compare-at-price');

    if (compareCents && compareCents > cents && saleWrap && regularWrap) {
      regularWrap.classList.add('price__hidden');
      saleWrap.classList.remove('price__hidden');
      if (salePrice) salePrice.textContent = moneyFromCents(cents);
      if (comparePrice) comparePrice.textContent = moneyFromCents(compareCents);
      if (regularPrice) regularPrice.textContent = moneyFromCents(cents);
      return;
    }

    if (regularWrap) regularWrap.classList.remove('price__hidden');
    if (saleWrap) saleWrap.classList.add('price__hidden');
    if (regularPrice) regularPrice.textContent = moneyFromCents(cents);
  }

  function neutralizeSeal(scope) {
    (scope || document)
      .querySelectorAll('.sealsubs-target-element, .sealsubs-container, [class*="sealsubs-"], [id*="sealsubs"]')
      .forEach(function (el) {
        if (el.closest('.kuleana-pack-picker, .kuleana-card-buy')) return;
        el.style.setProperty('display', 'none', 'important');
        el.setAttribute('hidden', '');
        el.setAttribute('inert', '');
        el.querySelectorAll('input, select, textarea, button').forEach(function (input) {
          if (input.name === 'selling_plan') {
            input.setAttribute('data-seal-selling-plan', input.value || '');
            input.removeAttribute('name');
          }
          input.disabled = true;
        });
      });
  }

  function keepOurSellingPlan(form, ourInput) {
    if (!form) return;
    form.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
      if (ourInput && input !== ourInput) {
        input.removeAttribute('name');
        input.disabled = true;
      }
    });
  }

  function bindPicker(picker) {
    var form = picker.closest('form') || picker.closest('product-form-component');
    if (!form) return;

    var unitCents = Number(picker.getAttribute('data-unit-cents') || '0');
    var packQty = Number(picker.getAttribute('data-pack-qty') || '1');
    var defaultPercent = Number(picker.getAttribute('data-sub-percent') || '0');
    var planInput = picker.querySelector('[data-selling-plan], input[name="selling_plan"]');
    var productRoot =
      picker.closest('.featured-product-information, .product-information, main') || document;
    var frequency = picker.querySelector('[data-frequency]');

    function currentQty() {
      var selected = picker.querySelector('[data-pack-input]:checked');
      return selected ? Number(selected.value || '1') : 1;
    }

    function isSubscribe() {
      var selected = picker.querySelector('[data-purchase-input]:checked');
      return !!(selected && selected.value === 'subscribe');
    }

    function selectedFrequency() {
      return picker.querySelector('[data-freq-input]:checked') || picker.querySelector('[data-freq-input]');
    }

    function currentPercent() {
      if (!isSubscribe()) return 0;
      var freq = selectedFrequency();
      if (freq) return Number(freq.getAttribute('data-plan-percent') || '0');
      return defaultPercent;
    }

    function currentPlanId() {
      if (!isSubscribe()) return '';
      var freq = selectedFrequency();
      if (freq && freq.value) return freq.value;
      return picker.getAttribute('data-sub-plan') || '';
    }

    function apply() {
      neutralizeSeal(document);
      keepOurSellingPlan(form, planInput);

      var qty = currentQty();
      var percent = currentPercent();
      var unit = discountedUnitCents(unitCents, percent);
      var oneTimeTotal = unitCents * qty;
      var displaySubPercent = isSubscribe() ? percent : defaultPercent;
      var subTotal = discountedUnitCents(unitCents, displaySubPercent) * qty;
      var selectedTotal = isSubscribe() ? subTotal : oneTimeTotal;

      setQuantity(form, qty);
      if (planInput) planInput.value = currentPlanId();
      if (frequency) frequency.hidden = !isSubscribe();
      var note = picker.querySelector('.kuleana-pack-picker__note');
      if (note) note.hidden = !isSubscribe();

      setSlot(picker, 'pack-1', unit);
      setSlot(picker, 'pack-n', unit * packQty);
      setSlot(picker, 'onetime', oneTimeTotal);
      setSlot(picker, 'subscribe', subTotal);

      picker.querySelectorAll('[data-freq-input]').forEach(function (input) {
        var slot = input.closest('label') && input.closest('label').querySelector('[data-price-slot="freq"]');
        if (!slot) return;
        var freqPercent = Number(input.getAttribute('data-plan-percent') || '0');
        slot.textContent = moneyFromCents(discountedUnitCents(unitCents, freqPercent) * qty);
      });

      var badge = picker.querySelector('[data-save-badge]');
      if (badge && displaySubPercent > 0) {
        badge.textContent = 'Save ' + displaySubPercent + '%';
      }

      updateMainPrice(productRoot, selectedTotal, isSubscribe() ? oneTimeTotal : 0);
    }

    picker.addEventListener('change', apply);
    form.addEventListener(
      'submit',
      function () {
        neutralizeSeal(document);
        apply();
      },
      true
    );

    apply();
  }

  function bindCardBuy(box) {
    var form = box.closest('form') || box.closest('product-form-component');
    if (!form) return;
    var unitCents = Number(box.getAttribute('data-unit-cents') || '0');
    var defaultPercent = Number(box.getAttribute('data-sub-percent') || '0');
    var card = box.closest('.rum-card') || box.parentElement;
    var priceEl = card && card.querySelector('[data-card-price]');
    var planInput = form.querySelector('[data-selling-plan], input[name="selling_plan"]');
    var frequency = box.querySelector('[data-frequency]');

    function currentQty() {
      var selected = box.querySelector('[data-pack-input]:checked');
      return selected ? Number(selected.value || '1') : 1;
    }

    function isSubscribe() {
      var selected = box.querySelector('[data-purchase-input]:checked');
      return !!(selected && selected.value === 'subscribe');
    }

    function selectedFrequency() {
      return box.querySelector('[data-freq-input]:checked') || box.querySelector('[data-freq-input]');
    }

    function currentPercent() {
      if (!isSubscribe()) return 0;
      var freq = selectedFrequency();
      if (freq) return Number(freq.getAttribute('data-plan-percent') || '0');
      return defaultPercent;
    }

    function currentPlan() {
      if (!isSubscribe()) return '';
      var freq = selectedFrequency();
      if (freq && freq.value) return freq.value;
      return box.getAttribute('data-sub-plan') || '';
    }

    function apply() {
      var qty = currentQty();
      var plan = currentPlan();
      var percent = currentPercent();
      var unit = discountedUnitCents(unitCents, percent);
      setQuantity(form, qty);
      if (planInput) planInput.value = plan;
      if (frequency) frequency.hidden = !isSubscribe();
      if (priceEl) priceEl.textContent = moneyFromCents(unit * qty);
      var badge = box.querySelector('[data-save-badge]');
      if (badge && (percent || defaultPercent)) {
        badge.textContent = (percent || defaultPercent) + '%';
      }
    }

    box.addEventListener('change', apply);
    apply();
  }

  function bindNotify() {
    var activeButton = null;

    function shopDomain(button) {
      return (
        (button && button.getAttribute('data-shop')) ||
        (window.Shopify && window.Shopify.shop) ||
        'kuleana-rum-works.myshopify.com'
      );
    }

    function ensureDialog() {
      var dialog = document.getElementById('kuleana-notify-dialog');
      if (dialog) return dialog;

      dialog = document.createElement('div');
      dialog.id = 'kuleana-notify-dialog';
      dialog.hidden = true;
      dialog.innerHTML =
        '<div class="kuleana-notify-dialog__backdrop" data-notify-close></div>' +
        '<div class="kuleana-notify-dialog__panel" role="dialog" aria-modal="true" aria-labelledby="kuleana-notify-title">' +
        '<button type="button" class="kuleana-notify-dialog__close" data-notify-close aria-label="Close">Close</button>' +
        '<h2 id="kuleana-notify-title">Notify me</h2>' +
        '<p class="kuleana-notify-dialog__product" data-notify-product></p>' +
        '<p class="kuleana-notify-dialog__copy">Get a notification as soon as this is back in stock.</p>' +
        '<form class="kuleana-notify-dialog__form">' +
        '<label class="kuleana-notify-dialog__label" for="kuleana-notify-email">Email</label>' +
        '<input id="kuleana-notify-email" class="kuleana-notify-dialog__input" type="email" name="email" autocomplete="email" required>' +
        '<button class="kuleana-notify-dialog__submit" type="submit">Notify me when available</button>' +
        '<p class="kuleana-notify-dialog__status" data-notify-status hidden></p>' +
        '</form>' +
        '</div>';

      var style = document.createElement('style');
      style.textContent =
        '#kuleana-notify-dialog{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:24px;}' +
        '#kuleana-notify-dialog[hidden]{display:none;}' +
        '.kuleana-notify-dialog__backdrop{position:absolute;inset:0;background:rgba(44,0,29,.55);}' +
        '.kuleana-notify-dialog__panel{position:relative;width:min(420px,100%);padding:28px 24px 24px;background:#f0ede2;color:#2c001d;}' +
        '.kuleana-notify-dialog__close{position:absolute;top:12px;right:12px;border:0;background:transparent;color:#2c001d;font-size:.8rem;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;}' +
        '#kuleana-notify-title{margin:0 0 8px;font-size:1.4rem;}' +
        '.kuleana-notify-dialog__product{margin:0 0 8px;font-weight:700;}' +
        '.kuleana-notify-dialog__copy{margin:0 0 16px;}' +
        '.kuleana-notify-dialog__label{display:block;margin:0 0 6px;font-size:.8rem;letter-spacing:.06em;text-transform:uppercase;}' +
        '.kuleana-notify-dialog__input{width:100%;min-height:48px;margin:0 0 12px;padding:0 12px;border:1px solid #2c001d;background:#fff;color:#2c001d;}' +
        '.kuleana-notify-dialog__submit{width:100%;min-height:48px;border:0;background:#2c001d;color:#f0ede2;font-weight:700;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;}' +
        '.kuleana-notify-dialog__status{margin:12px 0 0;}';
      document.head.appendChild(style);
      document.body.appendChild(dialog);

      dialog.addEventListener('click', function (event) {
        if (event.target.closest('[data-notify-close]')) closeDialog();
      });

      dialog.querySelector('form').addEventListener('submit', function (event) {
        event.preventDefault();
        submitNotify(dialog);
      });

      return dialog;
    }

    function openDialog(button) {
      activeButton = button;
      var dialog = ensureDialog();
      var product = dialog.querySelector('[data-notify-product]');
      var status = dialog.querySelector('[data-notify-status]');
      var input = dialog.querySelector('input[type="email"]');
      product.textContent = button.getAttribute('data-product-title') || '';
      status.hidden = true;
      status.textContent = '';
      input.value = '';
      dialog.hidden = false;
      input.focus();
    }

    function closeDialog() {
      var dialog = document.getElementById('kuleana-notify-dialog');
      if (dialog) dialog.hidden = true;
      activeButton = null;
    }

    function submitNotify(dialog) {
      if (!activeButton) return;
      var status = dialog.querySelector('[data-notify-status]');
      var email = dialog.querySelector('input[type="email"]').value.trim();
      var submit = dialog.querySelector('[type="submit"]');
      status.hidden = false;
      status.textContent = 'Saving...';
      submit.disabled = true;

      fetch('https://app.stoqapp.com/api/v1/intents.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Shop-Domain': shopDomain(activeButton)
        },
        body: JSON.stringify({
          intent: {
            shopify_variant_id: Number(activeButton.getAttribute('data-variant-id')),
            shopify_product_id: Number(activeButton.getAttribute('data-product-id')),
            channel: 'email',
            quantity: 1,
            source: 'api'
          },
          customer: { email: email }
        })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (result.ok && !result.data.errors) {
            status.textContent = 'Thank you. We will notify you when this is back in stock.';
            return;
          }
          var errors = result.data && result.data.errors;
          status.textContent =
            (errors && (errors.email || errors[0] || JSON.stringify(errors))) ||
            'Please enter a valid email address.';
        })
        .catch(function () {
          status.textContent = 'Please try again.';
        })
        .then(function () {
          submit.disabled = false;
        });
    }

    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest('[data-kuleana-notify]');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        openDialog(button);
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDialog();
    });
  }

  function hideCardSealWidgets() {
    document
      .querySelectorAll('.rum-card .sealsubs-target-element, .kuleana-card-buy ~ .sealsubs-target-element')
      .forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
  }

  function hideSameProductWidgets() {
    document.querySelectorAll('.bndlr-container[data-bundle-name]').forEach(function (el) {
      var name = el.getAttribute('data-bundle-name') || '';
      if (/4-Pack|2-Pack/.test(name)) {
        var wrap = el.closest('.bundler-target-element') || el;
        wrap.style.display = 'none';
      }
    });
  }

  function ensureFrequencyHideCss() {
    if (document.getElementById('kuleana-freq-hide')) return;
    var style = document.createElement('style');
    style.id = 'kuleana-freq-hide';
    style.textContent = '[data-frequency][hidden]{display:none!important}';
    document.head.appendChild(style);
  }

  function init() {
    ensureFrequencyHideCss();
    neutralizeSeal(document);
    bindNotify();
    document.querySelectorAll('.kuleana-pack-picker').forEach(bindPicker);
    document.querySelectorAll('.kuleana-card-buy').forEach(bindCardBuy);
    hideSameProductWidgets();
    hideCardSealWidgets();

    var observer = new MutationObserver(function () {
      neutralizeSeal(document);
      hideSameProductWidgets();
      hideCardSealWidgets();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    setTimeout(hideSameProductWidgets, 1500);
    setTimeout(hideCardSealWidgets, 1500);
    setTimeout(function () {
      neutralizeSeal(document);
    }, 1500);
    setTimeout(hideSameProductWidgets, 4000);
    setTimeout(hideCardSealWidgets, 4000);
    setTimeout(function () {
      neutralizeSeal(document);
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
